import { SideMenu as SideMenuRoot } from './SideMenu'
import { SideMenuAction } from './SideMenuAction'
import { SideMenuFooter } from './SideMenuFooter'
import { SideMenuGroup } from './SideMenuGroup'
import { SideMenuItem } from './SideMenuItem'
import { SideMenuSeparator } from './SideMenuSeparator'
import { SideMenuSubItem } from './SideMenuSubItem'

export const SideMenu = Object.assign(SideMenuRoot, {
  Item: SideMenuItem,
  Group: SideMenuGroup,
  SubItem: SideMenuSubItem,
  Separator: SideMenuSeparator,
  Footer: SideMenuFooter,
  Action: SideMenuAction,
})

export * from './types'
